export const SET_ERROR = '[ERROR_PROVIDER] SET_ERROR';
export const CLEAR_ERROR = '[ERROR_PROVIDER] CLEAR_ERROR';
